<template>
  <div
    class="modal fade"
    persistent
    :id="modalId"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog" :class="{ 'modal-lg': isLarge }">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ title }}</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
          ></button>
        </div>

        <div class="modal-body">
          <slot name="body">
            <p v-if="isDeleteConfirmation" v-html="deleteMessage"></p>
            <p v-else v-html="body"></p>
          </slot>
        </div>

        <div class="modal-footer d-flex justify-content-between align-items-center">
          <!-- Left-aligned Save Button -->
          <div>
            <button
              v-if="extraLeftButton"
              type="button"
              class="btn btn-primary"
              @click="$emit(extraLeftButton.emit)"
            >
              {{ extraLeftButton.text }}
            </button>
          </div>

          <!-- Right-aligned Close & Confirm -->
          <div class="d-flex gap-2">
            <button
              type="button"
              id="close"
              class="btn btn-secondary"
              v-if="useCustomClose"
              @click="$emit(customCloseEmits)"
            >
              {{ closeText }}
            </button>
            <button
              v-else
              type="button"
              id="close"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              {{ closeText }}
            </button>

            <template v-if="!hideConfirmButton">
              <button
                v-if="!isDeleteConfirmation"
                type="button"
                class="btn btn-primary"
                @click="$emit('confirm')"
              >
                {{ confirmText }}
              </button>
              <button
                v-else
                type="button"
                class="btn btn-danger"
                @click="$emit('confirm')"
              >
                {{ confirmText }}
              </button>
            </template>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "bootstrap";
export default {
  props: {
    modalId: { type: String, required: true },
    title: { type: String, default: "Modal Title" },
    body: { type: String, default: null },
    closeText: { type: String, default: "Close" },
    confirmText: { type: String, default: "Confirm" },
    isLarge: { type: Boolean, default: false },
    isDeleteConfirmation: { type: Boolean, default: false },
    hideConfirmButton: { type: Boolean, default: false },
    useCustomClose: { type: Boolean, default: false },
    customCloseEmits: { type: String, default: "close" },
    extraLeftButton: {
      type: Object,
      default: null
    },
    deleteMessage: {
      type: String,
      default: "Are you sure you want to delete this item?",
    },
  },
  methods: {
    show() {
      const modalElement = document.getElementById(this.modalId);
      if (modalElement) {
        const modalInstance = Modal.getOrCreateInstance(modalElement);
        modalInstance.show();
      }
    },
    hide() {
      const modalElement = document.getElementById(this.modalId);

      if (modalElement) {
        const closeButton = modalElement.querySelector(".btn-close");
        if (closeButton) {
          closeButton.click();
          return;
        }
      }
    },
  },
};
</script>